import axios from 'axios';

export default {
  setDefaultAvatar(teamAlias) {
    return axios
      .delete(`/api/team/${teamAlias}/avatar`)
      .then((res) => res.data)
      .catch((err) => {
        throw err;
      });
  },
  setTeamDefaultAvatarAdmin(teamAlias) {
    return axios
      .delete(`/api/admin/team/${teamAlias}/avatar`)
      .then((res) => res.data)
      .catch((err) => {
        throw err;
      });
  }
};
